import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import SearchView from "../../widgets/SearchView";
import LearnerDocumentSearchForm from './LearnerDocumentSearchForm';
import ViewUtils from '../../ViewUtils';
import AlertItem from "../../widgets/AlertItem";

// Material-UI Imports
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const headCells = [
    { id: "LearnerIDNumber", numeric: false, disablePadding: true, label: "Learner ID Number" },
    { id: "LearnerName", numeric: false, disablePadding: true, label: "Learner Name" },
    { id: "InterventionCode", numeric: false, disablePadding: true, label: "Intervention Code" },
    { id: "InterventionDescription", numeric: false, disablePadding: true, label: "Intervention Description" },
    { id: "TrainingProviderName", numeric: false, disablePadding: true, label: "Training Provider Name" },
];

const searchParameters = [
    { Name: "DocumentTypeID", Value: "" },
    { Name: "PrintTypeID", Value: "" },
    { Name: "ProgrammeTypeID", Value: "" },
    { Name: "ProgrammeID", Value: "" },
    { Name: "ProviderID", Value: "" },
    { Name: "LearnerID", Value: "" },
    { Name: "EmployerID", Value: "" },
    { Name: "StartDate", Value: "" },
    { Name: "EndDate", Value: "" },
    { Name: "FinancialYearID", Value: "" }
];

const utils = new ViewUtils();

class LearnerDocuments extends Component {
    constructor(props) {
        super(props);
        
        this.toolbarRef = React.createRef();
        this.searchFormRef = React.createRef();
        this.messageTimeout = null;

        this.state = {
            model: {
                DocumentTypeID: null,
                PrintTypeID: null,
                ProgrammeTypeID: null,
                ProgrammeID: null,
                ProviderID: null,
                EmployerID: null,
                LearnerID: null,
                StartDate: "",
                EndDate: "",
                FinancialYearID: null
            },
            selectedLearners: null,
            keyUpSwitch: false,
            clearGrid: false,
            documentGenerated: false,
            documentName: null,
            messageAlert: null,
            messageStyle: null,
            dependency: null,
            isConfirmDialogOpen: false // New state to control the MUI Dialog
        };

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { 
                            id: 'generate', 
                            label: 'Generate', 
                            icon: 'CreateIcon', 
                            tooltip: 'Generate letters / certificates', 
                            disabled: utils.isNull(this.state.selectedLearners) 
                        }
                    ]
                }
            ]
        };
    }

    componentWillUnmount() {
        if (this.messageTimeout) {
            clearTimeout(this.messageTimeout);
        }
    }

    displayMessage = (message, style, timeoutDuration = 6000) => {
        this.setState({ messageAlert: message, messageStyle: style });
        
        if (this.messageTimeout) {
            clearTimeout(this.messageTimeout);
        }
        
        this.messageTimeout = setTimeout(() => {
            this.setState({ messageAlert: null, messageStyle: null });
        }, timeoutDuration);
    }

    // Handles the initial generate button click
    handleToolbarButtonClick = (buttonId) => {
        if ("generate" === buttonId) {
            if (this.state.selectedLearners && this.state.selectedLearners.length > 10) {
                // Open the MUI dialog instead of stopping execution with window.confirm
                this.setState({ isConfirmDialogOpen: true });
            } else {
                // If 10 or fewer, proceed straight to generation
                this.executeGeneration();
            }
        }
    }

    // Modal Action: User clicked Cancel
    handleConfirmClose = () => {
        this.setState({ isConfirmDialogOpen: false });
    }

    // Modal Action: User clicked Continue
    handleConfirmProceed = () => {
        this.setState({ isConfirmDialogOpen: false }, () => {
            // Once state finishes updating, run the API call
            this.executeGeneration();
        });
    }

    // Separated the actual execution logic out so it can be called from multiple places
    executeGeneration = () => {
        this.generateDocuments();
        this.toolbarRef.current.setButtonDisabled("generate", true);
    }

    FileDownload = (documentName) => {
        utils.invokeUrl("api/sims/bulklearnercertificate/DownloadLearnerCertificates?FileName=" + documentName, (response) => {
            var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
            var url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = response.Name;
            link.target = '_blank';
            link.click();
            this.toolbarRef.current.setButtonDisabled("download", true);
        }, (e) => {
            this.displayMessage(utils.SYSTEM_ERROR_MESSAGE, "outlinedError");
        });
    };

    generateDocuments = () => {
        const LearnerProgrammeIDs = this.state.selectedLearners.map(e => e.Id);
        let data = {
            LearnerProgrammeIDs: LearnerProgrammeIDs,
            ...this.state.model
        };

        let url = "api/sims/bulklearnercertificate/GenerateLearnerCertificates";

        utils.invokeUrl(
            url,
            (response) => {
                if (this.state.selectedLearners.length <= 10) {
                    let documentInfo = JSON.parse(response.Message);
                    this.FileDownload(documentInfo.OriginalFileName);
                    this.toolbarRef.current.setButtonDisabled("download", !this.state.documentGenerated);
                    this.setState({ clearGrid: true });
                } else {
                    this.displayMessage(response.Message, response.MessageType);
                    this.setState({ clearGrid: true });
                }
            },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(data)
            }
        );
    };

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    onkeyup = (e) => {
        if (e.key === 'Enter') {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    handleSelectionChange = (selection) => {
        const hasSelection = selection !== null && selection.length !== 0;
        
        this.setState(
            { selectedLearners: hasSelection ? selection : null, messageAlert: null },
            () => {
                this.toolbarRef.current.setButtonDisabled("generate", !hasSelection);
            }
        );
    }

    handleFormValueChange = (values) => {
        let newValues = null;
        if (!utils.isNull(values)) {
            newValues = { ...values };
        }
        
        if (!utils.isNull(newValues)) {
            if (JSON.stringify(this.state.model) !== JSON.stringify(newValues)) {
                if (!utils.isNull(newValues.ProgrammeTypeID) && !utils.isNull(this.state.model.ProgrammeTypeID) && newValues.ProgrammeTypeID.Id !== this.state.model.ProgrammeTypeID.Id) {
                    newValues.ProgrammeID = null;
                }
                if (!utils.isNull(newValues.DocumentTypeID) && !utils.isNull(this.state.model.DocumentTypeID) && newValues.DocumentTypeID.Id !== this.state.model.DocumentTypeID.Id) {
                    newValues.PrintTypeID = null;
                }

                let stateUpdate = {
                    model: newValues,
                    clearGrid: true,
                    selectedLearners: null,
                    messageAlert: null 
                };

                if (!utils.isNull(newValues.DocumentTypeID) && JSON.stringify(this.state.dependency) !== JSON.stringify(newValues.DocumentTypeID)) {
                    const documentTypeID = {
                        Name: "DocumentTypeID",
                        Value: newValues.DocumentTypeID.Id
                    };
                    if (!utils.isNull(documentTypeID.Value)) {
                        stateUpdate.dependency = documentTypeID;
                    }
                }

                this.setState(stateUpdate);
                this.toolbarRef.current.setButtonDisabled("generate", true);
            }
        }
    }

    onSearchRequiredFieldCheck = () => {
        return !!this.searchFormRef.current.getValue();
    }

    onGridCleared = () => {
        this.setState({ clearGrid: false });
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                
                {this.state.messageAlert && (
                    <AlertItem
                        message={this.state.messageAlert}
                        alertStyle={this.state.messageStyle}
                    />
                )}
                
                <SearchView
                    headCells={headCells}
                    dataUrl="api/sims/bulklearnercertificate/getsearch"
                    model={this.state.model}
                    toolbarConfig={this.toolbarConfig}
                    searchParameters={searchParameters}
                    searchLabel="SEARCH"
                    mode={this.props.mode}
                    multiSelect={true}
                    onLookupValueChange={this.props.onLookupValueChange}
                    history={this.props.history}
                    buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch}
                    setSelection={this.handleSelectionChange}
                    autoFetchData={false}
                    toolbarRef={this.toolbarRef}
                    onSearchRequiredFieldCheck={this.onSearchRequiredFieldCheck}
                    clearGrid={this.state.clearGrid}
                    onGridCleared={this.onGridCleared}
                    title={"Learner Certificates and SOR/ROA"}
                    handleObject={true}
                >
                    <LearnerDocumentSearchForm
                        ref={this.searchFormRef}
                        data={this.state.model}
                        onKeyUp={this.onkeyup}
                        model={this.state.model}
                        valueChangeHandler={this.handleFormValueChange}
                        dependency={this.state.dependency}
                    />
                </SearchView>

                {/* Material UI Confirmation Dialog */}
                <Dialog
                    open={this.state.isConfirmDialogOpen}
                    onClose={this.handleConfirmClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Confirm Document Generation"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Please note that because more than 10 certificates are selected, the generated certificates will be emailed. 
                            <br/><br/>
                            Do you wish to continue?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleConfirmClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.handleConfirmProceed} color="primary" autoFocus variant="contained">
                            Continue
                        </Button>
                    </DialogActions>
                </Dialog>

            </ViewContainer>
        );
    }
}

export default withRouter(connect()(LearnerDocuments));